import { action as apiAction } from 'api/Api'
import {
  set as setElement,
} from '../redux/elements'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number;
  documentFolderId: number;
  documentSourceId: number;
  path?: string;
}

const requestChangeDocumentFolderPath = (payload: Payload) => async dispatch => {
  const { cardId, documentFolderId, documentSourceId, path } = payload

  const optimisticAction = optimisticDispatch(dispatch, setElement({
    cardId,
    element: {
      id: documentFolderId,
      documentSourceId,
      path,
    }
  }))

  try {
    await apiAction('ChangeDocumentsFolderPath', {
      documentsFolderId: documentFolderId,
      documentSourceId,
      path,
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}

export default requestChangeDocumentFolderPath